import {
  LOGIN, LOGOUT, CLEAR_ERRORS, GET_TOKEN, REFRESH, GET_USER, RESET_PASSWORD, FIRST_TIME_LOGIN,
  GET_VIOLATIONS, SEARCH_VIOLATIONS, SEARCH_VIOLATION_FILTERS, SET_FORM, SET_VIOLATIONS, SET_SEARCH_RESULTS,

  GET_COMMENTS, GET_ACTIONS, GET_HISTORY, GET_VIOLATION_TERMS, HAS_HISTORY, SET_FLAG, UPDATE_UNIT_TREE,
  UPDATE_VIOLATION
} from './violationTypes'

import {
  GET_SETTINGS, UPDATE_SETTINGS,

  GET_USER_GENERAL_SETTINGS, UPDATE_USER_GENERAL_SETTINGS,

  GET_ORG_CONTACTS, UPDATE_ORG_CONTACTS,
  GET_ORG_GENERAL_SETTINGS, UPDATE_ORG_GENERAL_SETTINGS,
  GET_ORG_LICENSE_SETTINGS, GET_ORG_EMAIL_SETTINGS, UPDATE_ORG_EMAIL_SETTINGS,
  GET_ORG_SETTINGS, UPDATE_ORG_SETTINGS,

  GET_USER_ROLE_SETTINGS,

  GET_USER_PERMISSIONS,
  GET_USER_ROLE_SUPERVISORS,

  GET_AUP_LIST, UPDATE_AUP, POST_AUP, DELETE_AUP,

  GET_APP_EXCLUSIONS, POST_APP_EXCLUSION, DELETE_APP_EXCLUSION,

  GET_ORGANIZATIONAL_UNIT_INFO, UPDATE_ORGANIZATIONAL_UNIT, UPDATE_UNIT_MONITORING,

  GET_WORD_VAULT, GET_CATEGORIES, GET_CATEGORY_EXCLUSIONS, CREATE_WORD, GET_WORD_DETAILS,

  GET_WHITELIST, GET_WHITELIST_SEARCH, RESET_WHITELIST_SEARCH,

  GET_USERS_LIST, GET_WORKSTATIONS_LIST,

  GET_SUPERVISOR_GROUPS, CREATE_NEW_SUPERVISOR_GROUP, UPDATE_SUP_GROUP, DELETE_SUP_GROUP,

  GET_USERS_REPORT, GET_PHRASES_REPORT, GET_WEBSITES_REPORT, SET_DEFAULT_REPORT, GET_SUPERVISOR_REPORT, GET_SUPERVISOR_USER_REPORT, GET_SUPERVISOR_LOGIN_REPORT, GET_SUPERVISOR_SINGLE_LOGIN_REPORT
} from './settingsTypes'

import {
  SET_VIEW, SET_PAGE_VIEW, SET_PRINT_CAPTURES, SET_CAPTURE_SELECTION, SET_CAPTURE_SELECTIONS,
  SET_SELECTED_VIOLATION_ID, SET_SELECTED_VIOLATION_KEY_NUMBER, SET_CAPTURES_RENDERED,
  SET_SCROLL_STATUS, SET_CAPTURE_MODAL_STATUS, SET_SETTINGS_MODAL_STATUS, SET_FILTER_MODAL_STATUS,
  SET_PRINTER_MODAL_STATUS, SET_EXPORT_MODAL_STATUS, SET_SHARE_MODAL_STATUS, SET_SEARCH_MODAL_STATUS, SET_FILTER, SET_PAGE,
  SET_PAGE_CAPTURE_LIMIT, SET_PAGE_CHANGED, SET_ALL_CHECKED, SET_REPORTS_MODAL_STATUS,
  SET_GROUP_INDEX, SET_FLAGGED_ONLY, SET_MY_SCHOOLS_STATUS, SET_SELECTED_CAPTURES, RESET_INITIAL_STATE, SET_DEFAULT_REPORT_SET,
  SET_DEFAULT_PAGE, SET_DEFAULT_VIEW, SET_DEFAULT_CAPTURE_COUNT,
  SET_FROM_VIEW, SET_AWAIT_TRIGGER, SET_STATUS_SNACK, SET_TRIGGER_FILTER, SET_FROM_LINK, SET_REPORT, SET_PAGE_TYPE,
  SET_CAPTURES_EXHAUSTED, SET_END_OF_LINK, SET_NEED_FILTER, SET_TEMPORARY_QUARANTINE_VIEW,
  SET_FROM_URL
} from './selectTypes'

import { GET_USER_FILTERS, GET_FILTER_DETAILS } from './filterTypes'

import { GET_ALERTS } from './alertTypes'

import { GET_AVAILABLE_USERS } from './groupTypes'

import { DATA_REQUEST, DATA_SUCCESS, DATA_ERROR, LOADING_STATE_RESET } from './loading'

import {
  GET_INTEGRATION_SETTINGS, SET_INTEGRATION_SETTINGS, GET_DESTINATION_REQUESTS, VALIDATE_SETTINGS, DELETE_CISCO_SETTINGS, ADD_DESTINATION_LIST,
  UPDATE_BLOCK_REQUEST, GET_DESTINATION_LISTS, DELETE_DESTINATION_LIST
} from './integrationTypes'

const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'

const GET_CAPTURE_DATA = 'GET_CAPTURE_DATA'

export {
  LOGIN, LOGOUT,
  CLEAR_ERRORS,
  REFRESH,
  GET_TOKEN, GET_USER, RESET_PASSWORD, FIRST_TIME_LOGIN, GET_VIOLATIONS,
  SEARCH_VIOLATIONS, SEARCH_VIOLATION_FILTERS, SET_FORM, SET_VIOLATIONS,
  UPDATE_VIOLATION, SET_SEARCH_RESULTS,

  GET_COMMENTS, GET_ACTIONS, GET_HISTORY, GET_VIOLATION_TERMS, HAS_HISTORY, SET_FLAG, UPDATE_UNIT_TREE,

  GET_SETTINGS, UPDATE_SETTINGS,

  GET_USER_GENERAL_SETTINGS, UPDATE_USER_GENERAL_SETTINGS,

  GET_ORG_CONTACTS, UPDATE_ORG_CONTACTS,
  GET_ORG_GENERAL_SETTINGS, UPDATE_ORG_GENERAL_SETTINGS,
  GET_ORG_LICENSE_SETTINGS, GET_ORG_SETTINGS, UPDATE_ORG_SETTINGS,
  GET_ORG_EMAIL_SETTINGS, UPDATE_ORG_EMAIL_SETTINGS,

  GET_USER_ROLE_SETTINGS,
  GET_USER_PERMISSIONS,
  GET_USER_ROLE_SUPERVISORS,

  GET_AUP_LIST, UPDATE_AUP, POST_AUP, DELETE_AUP,

  SET_VIEW, SET_PAGE_VIEW, SET_FILTER,
  SET_PRINT_CAPTURES, SET_REPORT,
  SET_CAPTURE_SELECTION, SET_CAPTURE_SELECTIONS, SET_CAPTURES_RENDERED,
  SET_SELECTED_VIOLATION_ID, SET_SELECTED_VIOLATION_KEY_NUMBER,
  SET_SCROLL_STATUS, SET_CAPTURE_MODAL_STATUS, SET_SETTINGS_MODAL_STATUS, SET_FILTER_MODAL_STATUS, SET_PRINTER_MODAL_STATUS, SET_EXPORT_MODAL_STATUS,
  SET_SHARE_MODAL_STATUS, SET_SEARCH_MODAL_STATUS,
  SET_PAGE, SET_PAGE_CAPTURE_LIMIT, SET_PAGE_CHANGED, SET_ALL_CHECKED,
  SET_MY_SCHOOLS_STATUS, SET_SELECTED_CAPTURES, SET_REPORTS_MODAL_STATUS,
  SET_GROUP_INDEX, SET_FLAGGED_ONLY,

  GET_APP_EXCLUSIONS, POST_APP_EXCLUSION, DELETE_APP_EXCLUSION,

  GET_ORGANIZATIONAL_UNIT_INFO, UPDATE_ORGANIZATIONAL_UNIT, UPDATE_UNIT_MONITORING,

  GET_WORD_VAULT, GET_CATEGORIES, GET_CATEGORY_EXCLUSIONS, CREATE_WORD, GET_WORD_DETAILS,

  GET_WHITELIST, GET_WHITELIST_SEARCH, RESET_WHITELIST_SEARCH,

  GET_NOTIFICATIONS, GET_CAPTURE_DATA,

  GET_ALERTS, GET_USERS_LIST, GET_WORKSTATIONS_LIST,

  GET_SUPERVISOR_GROUPS, CREATE_NEW_SUPERVISOR_GROUP, GET_AVAILABLE_USERS, UPDATE_SUP_GROUP, DELETE_SUP_GROUP,

  SET_DEFAULT_REPORT, SET_DEFAULT_REPORT_SET, SET_DEFAULT_PAGE, SET_DEFAULT_VIEW, SET_DEFAULT_CAPTURE_COUNT,
  SET_FROM_VIEW, SET_AWAIT_TRIGGER, SET_STATUS_SNACK, SET_TRIGGER_FILTER, SET_FROM_LINK,
  GET_USERS_REPORT, GET_PHRASES_REPORT, GET_WEBSITES_REPORT, GET_SUPERVISOR_REPORT, GET_SUPERVISOR_USER_REPORT, GET_SUPERVISOR_LOGIN_REPORT, GET_SUPERVISOR_SINGLE_LOGIN_REPORT, SET_PAGE_TYPE,

  SET_CAPTURES_EXHAUSTED, SET_END_OF_LINK, SET_NEED_FILTER, SET_TEMPORARY_QUARANTINE_VIEW,

  SET_FROM_URL,

  GET_USER_FILTERS, GET_FILTER_DETAILS,

  DATA_REQUEST, DATA_SUCCESS, DATA_ERROR, LOADING_STATE_RESET,

  RESET_INITIAL_STATE,

  GET_INTEGRATION_SETTINGS, SET_INTEGRATION_SETTINGS, GET_DESTINATION_REQUESTS, VALIDATE_SETTINGS, DELETE_CISCO_SETTINGS, ADD_DESTINATION_LIST,
  UPDATE_BLOCK_REQUEST, GET_DESTINATION_LISTS, DELETE_DESTINATION_LIST
}
